<!--隐私协议-->
<template>
    <div class="reload-view">
        <div class="title-big">
            <h1>Hello</h1>
        </div>
        <div class="title-text">
            欢迎来到兼职红娘邀请码推广系统
        </div>


        <div class="mobile-input">
            <input class="phone" v-model="mobile" type="number" name="phone" placeholder="请输入手机号">
        </div>

        <div class="code-input">
            <input class="code" type="number" name="code" v-model="code" placeholder="请输入验证码">
            <span v-if="timerActive" @click="onSendCode">{{ timeRemaining }}秒后重发</span>
            <span v-else @click="onSendCode">发送验证码</span>
        </div>

        <div class="reload-btn" @click="onApplyCall">
            登录
        </div>

        <div class="footer">
            <p>江苏爱驿站信息科技有限公司</p>
            <p>Copyright © 2014-2025 Aiyizhan All Rights Reserved</p>
        </div>

    </div>
</template>

<script setup>
import {ref} from 'vue';
import {verifyPhone} from "@/assets/js/common";
import {showFailToast} from "vant";
import {useRouter} from "vue-router";
import ayzAjax from "@/plugins/axios";

const router = useRouter()
const mobile = ref('');
const code = ref('');
const timerActive = ref(false);
const timeRemaining = ref(60);

const onSendCode = async () => {
    if(!verifyPhone(mobile.value)){
        return showFailToast('手机号格式不正确!');
    }
    if (timeRemaining.value > 0 && timeRemaining.value !== 60) {
        return false;
    }
    timerActive.value = true;
    let interval = setInterval(() => {
        if (timeRemaining.value > 0) {
            timeRemaining.value--;
        } else {
            timerActive.value = false;
            timeRemaining.value = 60;
            clearInterval(interval);
        }
    }, 1000);

    let fromData = {};
    fromData.mobile = mobile.value;
    fromData.sms_type = 'SmsReferralLogin';
    try {
        ayzAjax.post('/referral/send_sms',fromData).then((response) => {
            if(response.data.code !== 200){
                return showFailToast(response.data.msg)
            }
        })
    }catch(err) {
        await router.push({path: '/referral/index'});
        console.log(err);
        showFailToast('网络错误,请稍后再试');
    }

};

const onApplyCall = async () => {
    if(!verifyPhone(mobile.value)){
        return showFailToast('手机号格式不正确!');
    }
    if (code.value.toString().length !== 4) {
        return showFailToast('验证码错误!');
    }
    let fromData = {};
    fromData.mobile = mobile.value;
    fromData.verify_code = code.value;
    ayzAjax.post('/referral/sms_login',fromData).then((response) => {
        if(response.data.code !== 200){
            return showFailToast(response.data.msg)
        }
        localStorage.setItem('jwtInfo', JSON.stringify(response.data.data.jwt_info));
        router.push({ path: '/referral/index'});
    })
}

</script>

<style lang="scss" scoped>

.reload-view{
    background-color: #FFFFFF;
    text-align: left;
    padding: 40px 30px 0 30px;
    .title-big{
        margin: 10px 10px 40px 10px;
    }
    .title-text{
        margin: 20px 10px 0 10px;
        font-weight: 550;
        font-size: 15px;
    }
    .mobile-input{
        //width: 100%;
        margin-top: 80px;
        height: 50px;
        background-color: #F7F8FA;
        line-height: 50px;
        padding-left: 10px;
        border-radius: 15px;
        .phone{
            //width: 100%;
            background-color: #F7F8FA;
            border: 0;
            border-radius: 15px;
        }
    }
    .code-input{
        display: flex;
        //width: 100%;
        margin-top: 20px;
        height: 50px;
        background-color: #F7F8FA;
        line-height: 50px;
        padding-left: 10px;
        border-radius: 15px;
        .code{
            background-color: #F7F8FA;
            border: 0;
            border-radius: 15px;
        }
    }
    .reload-btn{
        margin-top: 80px;
        height: 60px;
        line-height: 60px;
        background-color: #FE405F;
        color: #fff;
        text-align: center;
        border-radius: 10px;
    }
    .footer{
        margin-top: 120px;
        padding-bottom: 20px;
        text-align: center;
        color: #A5A5A5;
        font-weight: 300;
        font-size: 13px;
    }
}
</style>
